import React from 'react'
import logo from '../../assets/img/logo.png'
import type { ImageProps } from '@ztechapps/webui.util'
import { Image } from '@ztechapps/webui.util'
export default function Logo(props: Partial<ImageProps>) {
  return <Image {...props} url={logo} name="App Logo" />
}
